// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleThemeButton_toggle__1b4Q7","day":"ToggleThemeButton_day__1Z-fo"};